import script from "./BlogDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogDetail.vue?vue&type=script&lang=ts&setup=true"

import "./BlogDetail.vue?vue&type=style&index=0&id=735a8dbc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735a8dbc"]])

export default __exports__